import { render, staticRenderFns } from "./Homepage.vue?vue&type=template&id=33f5010f&scoped=true"
import script from "./Homepage.vue?vue&type=script&lang=js"
export * from "./Homepage.vue?vue&type=script&lang=js"
import style0 from "./Homepage.vue?vue&type=style&index=0&id=33f5010f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f5010f",
  null
  
)

export default component.exports